import Notification from '../../core/Notification';
import ProjectImport from '../../core/project/ProjectImport';
import ProjectProvider from '../providers/ProjectProvider';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import withGS from '../withGShoc';
import VersionWarning from '../VersionWarning';

class ProjectImportContainer extends Component {

  render() {

    const { id, data, baseLink, graph, projectType } = this.props;

    if (data.isVersionOfProject) return <VersionWarning/>;
    if (projectType && projectType !== data.type) return <Notification text="You are trying to view an incorrect project type."/>;

    return (
      <ProjectProvider value={data}>
        <ProjectImport
          {...this.props}
          id={id}
          disableScreen={true}
          enableSpreadsheet={true}
          baseLink={baseLink}
          project={id}
          graph={graph}
          data={data}
        />
      </ProjectProvider>
    );
  }
}

ProjectImportContainer.propTypes = {
  subLink: PropTypes.string,
  data: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  collections: PropTypes.array,
  taxonomies: PropTypes.array,
  projectType: PropTypes.string,
  optionForXL: PropTypes.bool,
  graph: PropTypes.string.isRequired,
  baseLink: PropTypes.string.isRequired
};

export default withGS(ProjectImportContainer);